import React from 'react';

import { OSLO_GRAY } from '@wetransfer/transfer/constant/colors';

interface InfoCircleProps {
  className?: string;
  iconColor?: string;
}

const InfoCircle = ({ className, iconColor = OSLO_GRAY }: InfoCircleProps) => (
  <svg className={className} viewBox="0 0 16 16" fill="none">
    <g>
      <ellipse cx="8" cy="5" rx="1" ry="1" fill={iconColor} />
      <path
        d="M8 15.25C3.99594 15.25 0.75 12.0041 0.75 8C0.75 3.99594 3.99594 0.75 8 0.75C12.0041 0.75 15.25 3.99594 15.25 8C15.25 12.0041 12.0041 15.25 8 15.25Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 8.3335V11.0002"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default InfoCircle;
